import React from "react";

import { Button, Stack, Tooltip } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import ControlPointDuplicateIcon from "@mui/icons-material/ControlPointDuplicate";
import ContentPasteSearchIcon from "@mui/icons-material/ContentPasteSearch";
import LibraryAddOutlinedIcon from "@mui/icons-material/LibraryAddOutlined";
import { useDrawingBomContext } from "../DrawingBomContext";
import ChangeHistoryIcon from "@mui/icons-material/ChangeHistory";

import SimCardDownloadIcon from "@mui/icons-material/SimCardDownload";
import PrintToPDF from "../DrawingBomContext/PrintToPDF";
import { drawingMaterialsCols } from "../../Components/cols/drawingsMaterialsCols";
import { drawingMcsDataCols } from "../../Components/cols/drawingMaterialsMcsDataCols";
import Table from "../../../../../../../components/Tables/NonEditableTable";
import { MaterialReactTable } from "material-react-table";
import { MCSContext } from "../../MCS.context";

const btnStyle = { mx: 0.4, my: 0.5, flexGrow: 1 };
export default function TabControl() {
  const {
    onRemoveAll,
    onConsolidate,
    onAddSrv,
    selectedDrawings,
    onCompare,
    onClickMtr,
  } = useDrawingBomContext();

  const printRef = React.useRef();

  const { setCurrentTab } = React.useContext(MCSContext);

  const onClickReconcile = () => {
    setCurrentTab(4);
  };

  console.log({ selectedDrawings });
  return (
    <>
      <Stack
        // spacing={{ xs: 1, sm: 2 }}
        direction="row"
        useFlexGap
        sx={{ flexWrap: "wrap" }}
      >
        <Button
          variant="contained"
          color="error"
          startIcon={<DeleteIcon />}
          sx={btnStyle}
          onClick={onRemoveAll}
        >
          Remove All
        </Button>

        <Button
          variant="contained"
          startIcon={<ControlPointDuplicateIcon />}
          sx={btnStyle}
          onClick={onConsolidate}
        >
          Consolidate
        </Button>

        <Button
          variant="contained"
          startIcon={<LibraryAddOutlinedIcon />}
          sx={btnStyle}
          onClick={onAddSrv}
        >
          Add SRV
        </Button>

        <Button
          variant="contained"
          startIcon={<ChangeHistoryIcon />}
          sx={btnStyle}
          onClick={onCompare}
          // disabled={selectedDrawings.length < 2}
        >
          Validate
        </Button>
      </Stack>
      <Stack direction="row" useFlexGap sx={{ flexWrap: "wrap" }}>
        <Button
          variant="contained"
          startIcon={<AccountTreeIcon />}
          sx={btnStyle}
          onClick={onClickReconcile}
        >
          Reconcile
        </Button>
        <Tooltip title="Material Traceability Record" placement="top">
          <Button
            variant="contained"
            startIcon={<ContentPasteSearchIcon />}
            sx={btnStyle}
            onClick={onClickMtr}
          >
            MTR
          </Button>
        </Tooltip>

        <Tooltip
          title="Download a PDF file of selected Drawings data"
          placement="top"
        >
          <Button
            variant="contained"
            startIcon={<SimCardDownloadIcon />}
            sx={btnStyle}
            disabled={!selectedDrawings[0]}
            onClick={() => {
              printRef.current.generatePDF();
              console.log({ selectedDrawings });
            }}
          >
            Save as PDF
          </Button>
        </Tooltip>
      </Stack>

      <PrintToPDF
        ref={printRef}
        header={
          "Drawing Bom (No. " +
          selectedDrawings[0]?.dwgNumber +
          "(Rev: " +
          selectedDrawings[0]?.revision +
          ")) Details."
        }
        tableComponent={
          <MaterialReactTable
            columns={[
              ...drawingMaterialsCols(selectedDrawings[0]?.materials),
              ...drawingMcsDataCols,
            ]}
            // data={selectedDrawings[0]?.materials}
            data={selectedDrawings[0]?.materials || []}
            enableTopToolbar={false}
            enableBottomToolbar={false}
            enablePagination={false}
            enableColumnActions={false}
            enableSorting={false}
            enableFilters={false}
            enableFullScreenToggle={false}
            enableDensityToggle={false}
            initialState={{
              pagination: { pageSize: 50, pageIndex: 0 },
            }}
            muiTableHeadCellProps={{
              sx: {
                border: "0.5px solid rgba(81, 81, 81, .1)",
                // fontStyle: 'italic',
                fontWeight: "normal",
                padding: "10px",
                backgroundColor: "#f3f1fe",
              },
            }}
            muiTableBodyCellProps={{
              sx: {
                border: "1px solid rgba(81, 81, 81, .1)",
                padding: "10px",
              },
            }}
          />
        }
      />
    </>
  );
}
